import React from 'react';
import { Link } from 'react-router-dom';

export function formatDate(iso, lang) {
  return new Date(iso).toLocaleDateString(lang === 'en' ? 'en-GB' : 'es-ES', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

export function NoteList({ items, lang }) {
  return (
    <ul className="notes">
      {items.map((post) => {
        const d = post[lang] || post.es;
        return (
          <li key={post.slug}>
            <Link to={`/blog/${post.slug}`}>
              <span className="n-date"><time dateTime={post.date}>{formatDate(post.date, lang)}</time></span>
              <span className="n-title">{d.title}</span>
              <span className="n-cat">{d.category} · {post.readTime}</span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
